/**
 * GOLD ORG — extracted from Figma file bhLleUtQOZbRFOCk5VCa9I (GOLD ORG page 3:4).
 * Coordinates are slide-local (1080×1920) where x ≤ 1080; typography from layer bounds.
 */
export const FIGMA_NODES = {
  entry: '3455:352',
  camera: '3455:372',
  countdown: '3455:391',
  preview: '3455:436',
  processing: '3455:685',
  result: '3455:456',
};

export const FIGMA_SPEC = {
  entry: {
    logo: { w: 309, h: 114, padTop: 81, padLeft: 80 },
    headline: { fontSize: 80, maxW: 839, lineHeight: 1.05 },
    subtitle: { w: 790, h: 94, fontSize: 32, marginTop: 36 },
    ctaMarginTop: 64,
    heroPadTop: 120,
    ctaOuter: { w: 707, h: 151, padX: 28, padY: 12 },
    ctaInner: { h: 127 },
    ctaLabel: { fontSize: 38 },
    ctaArrow: { w: 96, h: 96 },
    ctaIcon: { w: 26, h: 26 },
    ctaBottom: 64,
    mainPadX: 80,
  },
  /** Shared capture / countdown / preview — fixed slots prevent layout shift */
  cameraFlow: {
    headerTop: 145,
    headerGap: 20,
    headerW: 943,
    titleSlotH: 119,
    titleFontSize: 96,
    hint: { w: 790, h: 88, fontSize: 32, lineHeight: 1.35 },
    frameMarginTop: 56,
    actionDockH: 160,
    captureOverlap: 85,
  },
  camera: {
    header: { w: 790, gap: 67 },
    title: { w: 441, h: 119, fontSize: 96, lineHeight: 1.12 },
    hint: { w: 790, h: 108, fontSize: 28, lineHeight: 1.45 },
    headerTop: 145,
    frame: { w: 943, h: 1069, left: 69, top: 69, radius: 20, border: 2 },
    corner: { arm: 52, inset: 18 },
    capture: { w: 170, h: 170, left: 455, overlap: 85 },
    countdown: { w: 170, h: 170 },
  },
  preview: {
    title: { text: 'Continue?' },
    frame: { w: 943, h: 1069 },
    actionsRowW: 943,
    actionsGap: 40,
    actionsMarginTop: 36,
    retakeBar: { w: 451, h: 88 },
    continueBar: { w: 451, h: 88 },
    btnText: { fontSize: 32 },
    btnArrow: { w: 68.588, h: 68.588 },
  },
  processing: {
    title: { w: 702, h: 238, fontSize: 52, top: 189 },
    ring: { w: 637, h: 654, left: 641, top: 221, inner: 537 },
    percent: { fontSize: 64 },
    status: { left: 394, top: 203, w: 683 },
    sparkles: { w: 165, h: 165, left: 412, top: 203 },
    statusText: { w: 492, h: 116, fontSize: 30, lineHeight: 1.35 },
  },
  result: {
    padX: 80,
    title: { w: 800, h: 238, fontSize: 48, top: 135, lineHeight: 1.08 },
    card: { w: 704, h: 941, gapAfterTitle: 32 },
    cardLogo: { w: 228, h: 84, left: 39, top: 39 },
    sharePanelMaxW: 920,
    sharePanelMarginTop: 28,
    sharePanelGap: 24,
    qrBox: { w: 214, h: 208 },
    scanLabel: { fontSize: 24 },
    divider: { h: 281 },
    shareLabel: { fontSize: 24 },
    emailField: { w: 477, h: 63, padX: 31, padY: 12 },
    emailFont: 26,
    sendBtn: { h: 69 },
    homeBtn: { w: 477, h: 69, marginTop: 20 },
    homeArrow: { w: 68.588, h: 68.588 },
  },
};
